import React from 'react';
import * as formik from 'formik';
import { Button, Row, Form, Col } from 'react-bootstrap';
import axios from 'axios';
import { hba1cGoalValidationSchema } from '../../../../validations/hba1cGoalValidation';
import classNames from 'classnames';
import { trackEvent } from '../../../../utils/analytics';
interface HbA1CGoalFormProps {
  onClose: (isAdded: boolean) => void;
  patientId: any;
}

const HbA1CGoalForm: React.FC<HbA1CGoalFormProps> = ({
  onClose,
  patientId
}) => {
  const { Formik } = formik;
  const token = localStorage.getItem('token');
  const handleSubmit = async (values: any) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_ENDPOINT}/clinic/goals`,
        {
          patient_id: patientId,
          type: 'hba1c',
          current_date: new Date().toISOString().split('T')[0],
          ...values
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      const currentUser = JSON.parse(localStorage.getItem('user') || '{}');

      trackEvent('goal_created', {
        goal_type: 'hba1c',
        actor_user_id: String(currentUser.id || ''),
        actor_user_name: `${currentUser.firstname || ''} ${
          currentUser.lastname || ''
        }`.trim(),
        actor_role:
          currentUser.role?.toLowerCase() === 'clinic'
            ? 'clinic admin'
            : currentUser.role || '',
        platform: 'web'
      });

      onClose(true);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Formik
      initialValues={{ current_value: '', target_value: '', target_date: '' }}
      validationSchema={hba1cGoalValidationSchema}
      onSubmit={handleSubmit}
    >
      {({
        handleSubmit,
        handleChange,
        values,
        touched,
        errors,
        dirty,
        setValues
      }) => (
        <Form noValidate onSubmit={handleSubmit}>
          <Row className={classNames('g-3')}>
            <Col>
              <Form.Group className="mb-2">
                <Form.Label>Current HbA1C</Form.Label>
                <Form.Control
                  type="number"
                  step="0.1"
                  name="current_value"
                  value={values.current_value}
                  onChange={handleChange}
                  isValid={touched.current_value && !errors.current_value}
                  isInvalid={touched.current_value && !!errors.current_value}
                />
                <Form.Control.Feedback type="invalid">
                  {' '}
                  {errors.current_value}{' '}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Target HbA1C</Form.Label>
                <Form.Control
                  type="number"
                  step="0.1"
                  name="target_value"
                  value={values.target_value}
                  onChange={handleChange}
                  isValid={touched.target_value && !errors.target_value}
                  isInvalid={touched.target_value && !!errors.target_value}
                />
                <Form.Control.Feedback type="invalid">
                  {' '}
                  {errors.target_value}{' '}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row className={classNames('g-3')}>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Target Date</Form.Label>
                <Form.Control
                  type="date"
                  name="target_date"
                  value={values.target_date}
                  onChange={handleChange}
                  min={
                    new Date(Date.now() + 24 * 60 * 60 * 1000)
                      .toISOString()
                      .split('T')[0]
                  }
                  isValid={touched.target_date && !errors.target_date}
                  isInvalid={touched.target_date && !!errors.target_date}
                />
                <Form.Control.Feedback type="invalid">
                  {' '}
                  {errors.target_date}{' '}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <div className="text-end mt-3 mb-3">
            <Button type="submit" variant="primary">
              Save HbA1C Goal
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default HbA1CGoalForm;
